import React from "react";
import { StatusBadge } from "../../../shared/components/badges/StatusBadge";
import { ExpandedAccordion } from "../../../shared/components/ui/ExpandedAccordion";

const MedicalStaffExpandedRow = ({ item }) => {
  const sections = [
    {
      id: "personal",
      title: "Personal Info",
      fields: [
        { label: "Email", value: item.email || "—" },
        { label: "Phone", value: item.phone || "—" },
        { label: "Date of Birth", value: item.dateOfBirth || "—" },
        { label: "Address", value: item.address || "—", isLong: true },
      ],
    },
    {
      id: "professional",
      title: "Professional Details",
      fields: [
        { label: "Specialization", value: item.specialization || "—" },
        { label: "License Number", value: item.licenseNumber || "—" },
        { label: "Qualifications", value: item.qualifications || "—", isLong: true },
      ],
    },
    {
      id: "employment",
      title: "Employment Info",
      fields: [
        { label: "Joining Date", value: item.joiningDate || "—" },
        { label: "Salary", value: item.salary || "—" },
        { label: "Working Hours", value: item.workingHours || "—" },
        { label: "Medical History", value: item.medicalHistory || "—", isLong: true },
        { label: "Notes", value: item.notes || "—", isLong: true },
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default MedicalStaffExpandedRow;
